import { getHuckConfig } from '../../utils/getHuckConfig.js';
import { EmbeddedPodlet } from '../embedded-podlet.js';

export const UsedCarGuaranteeWidget = () => {
  const config = getHuckConfig();
  const content = config.pfBbgContent?.trim();
  return content ? <EmbeddedPodlet content={config.pfBbgContent} /> : null;
};
